export const addNamespace = (moduleName, actionsOrMutationsObject) => {
  return Object.fromEntries(
    Object.entries(actionsOrMutationsObject).map(([key, value]) => [
      key,
      moduleName + "/" + value,
    ])
  );
};
